export default __webpack_public_path__ + "static/media/area.07eba6b7.png";